import { CboSelectModel, EnderecoFieldGroupModel, MunicipioSelectModel, SimNaoEnum } from 'components/form'
import { EscolaridadeSelectModel } from 'components/form/field/select/EscolaridadeSelectField'
import { EstadoCivilSelectModel } from 'components/form/field/select/EstadoCivilSelectField'
import { EtniaSelectFieldModel } from 'components/form/field/select/EtniaSelectField'
import { PaisSelectFieldModel } from 'components/form/field/select/PaisSelectField'
import { RacaCorSelectModel } from 'components/form/field/select/RacaCorSelectField'
import { TipoSanguineoSelectModel } from 'components/form/field/select/TipoSanguineoSelectField'
import { LotacaoResponsavelFormModel } from 'components/lotacao-responsavel/model-lotacaoResponsavel'
import {
  CidadaoFciAtualizacaoQuery,
  Criancas0a9AnosComQuemFicaEnum,
  DeficienciaEnum,
  DoencaCardiacaAutorreferidoEnum,
  DoencaRespiratoriaAutorreferidoEnum,
  DoencaRinsAutorreferidoEnum,
  EscolaridadeEnum,
  EstadoCivilEnum,
  HigienePessoalEnum,
  IdentidadeGeneroEnum,
  NacionalidadeEnum,
  OrientacaoSexualEnum,
  OrigemAlimentacaoEnum,
  PesoAutorreferidoEnum,
  PovoComunidadeTradicionalEnum,
  QuantidadeAlimentacaoDiariaEnum,
  SexoEnum,
  SituacaoMercadoTrabalhoEnum,
  TempoSituacaoDeRuaEnum,
} from 'graphql/types.generated'

import { ContatosFormModel } from '../types/model-cidadao'

export interface DadosPessoaisFormModel {
  cpf?: string
  cns?: string
  nisPisPasep?: string
  nome: string
  nomeSocial?: string
  dataNascimento: string
  sexo: SexoEnum
  estadoCivil?: EstadoCivilSelectModel
  tipoSanguineo?: TipoSanguineoSelectModel
  racaCor: RacaCorSelectModel
  etnia?: EtniaSelectFieldModel
  nomeMae?: string
  nomePai?: string
  desconheceNomeMae: boolean
  desconheceNomePai: boolean
  nacionalidadeCidadao: NacionalidadeFormModel
  desejaInformarOrientacaoSexual: SimNaoEnum
  orientacaoSexual?: OrientacaoSexualEnum
  desejaInformarIdentidadeGenero: SimNaoEnum
  identidadeGenero?: IdentidadeGeneroEnum
  faleceu?: boolean
  dataObito?: LocalDate
  numeroDeclaracaoObito?: string
}

export const PAIS_BRASIL = { id: '31', nome: 'BRASIL' }

export interface SituacaoRuaFormModel {
  openedAccordion?: (string | number)[]
  tempoSituacaoRua?: TempoSituacaoDeRuaEnum
  recebeAlgumBeneficio?: SimNaoEnum
  possuiReferenciaFamiliar?: SimNaoEnum
  quantidadeAlimentacaoDiaria?: QuantidadeAlimentacaoDiariaEnum
  origemAlimentacao?: OrigemAlimentacaoEnum[]
  stAcompanhadoOutraInstituicao?: SimNaoEnum
  instituicaoAcompanhamento?: string
  possuiAcessoHigienePessoal?: SimNaoEnum
  higienePessoal?: HigienePessoalEnum[]
  visitaFamiliarComFrequencia?: SimNaoEnum
  grauParentescoVisitaFamiliar?: string
}

export interface InformacoesSocioEconomicasFormModel {
  openedAccordion?: (string | number)[]
  alimentosAcabaramAntesTerDinheiroComprarMais: SimNaoEnum
  comeuAlgunsAlimentosDinheiroAcabou: SimNaoEnum
}

export interface InformacoesSociodemograficasFormModel {
  openedAccordion?: (string | number)[]
  escolaridade?: EscolaridadeSelectModel
  frequentaEscolaOuCreche?: SimNaoEnum
  criancas0a9anosComQuemFica?: Criancas0a9AnosComQuemFicaEnum[]
  situacaoMercadoTrabalho?: SituacaoMercadoTrabalhoEnum
  ocupacao?: CboSelectModel
  possuiPlanoSaudePrivado?: SimNaoEnum
  frequentaCuidadorTradicional?: SimNaoEnum
  participaAlgumGrupoComunitario?: SimNaoEnum
  isMembroComunidadeTradicional?: SimNaoEnum
  povoComunidadeTradicional?: PovoComunidadeTradicionalEnum
  possuiDeficiencia?: SimNaoEnum
  deficiencias?: DeficienciaEnum[]
}

export interface InformacoesSocioEconomicasFormModel {
  openedAccordion?: (string | number)[]
  alimentosAcabaramAntesTerDinheiroComprarMais: SimNaoEnum
  comeuAlgunsAlimentosDinheiroAcabou: SimNaoEnum
}

export interface CondicoesSaudeAutorreferidasFormModel {
  openedAccordion?: (string | number)[]
  stGestante: SimNaoEnum
  maternidadeReferencia: string
  autodenominacaoPeso: PesoAutorreferidoEnum
  stAcamado: SimNaoEnum
  stDomiciliar: SimNaoEnum
  stFumante: SimNaoEnum
  stUsoAlcool: SimNaoEnum
  stUsoOutrasDrogas: SimNaoEnum
  stPraticasComplementares: SimNaoEnum
  stProblemaSaudeMental: SimNaoEnum
  stHipertensaoArterial: SimNaoEnum
  stDiabetes: SimNaoEnum
  stCancer: SimNaoEnum
  stDerrame: SimNaoEnum
  stInfarto: SimNaoEnum
  stHanseniase: SimNaoEnum
  stTuberculose: SimNaoEnum
  stDoencaCardiaca: SimNaoEnum
  doencaCardiaca: DoencaCardiacaAutorreferidoEnum[]
  stProblemaRins: SimNaoEnum
  doencaRins: DoencaRinsAutorreferidoEnum[]
  stDoencaRespiratoria: SimNaoEnum
  doencasRespiratorias: DoencaRespiratoriaAutorreferidoEnum[]
  stInternacaoUltimos12Meses: SimNaoEnum
  causaInternacaoUltimos12Meses: string
  stPlantasMedicinais: SimNaoEnum
  plantasMedicinais: string
  condicaoSaude1: string
  condicaoSaude2: string
  condicaoSaude3: string
}

export interface ResponsabilidadeAcompanhamentoFormModel {
  microarea?: string
  statusForaArea?: boolean
  statusCidadaoSaiuTerritorio?: boolean
  responsavel: LotacaoResponsavelFormModel
}

export interface CidadaoFciFormModel {
  id?: ID
  dadosPessoais: DadosPessoaisFormModel
  contatos: ContatosFormModel
  endereco: EnderecoFieldGroupModel
  informacoesSocioEconomicas: InformacoesSocioEconomicasFormModel
  responsabilidadeAcompanhamento: ResponsabilidadeAcompanhamentoFormModel
  informacoesSociodemograficas: InformacoesSociodemograficasFormModel
  statusSituacaoRua: SimNaoEnum
  situacaoRua: SituacaoRuaFormModel
  condicoesSaudeAutorreferidas: CondicoesSaudeAutorreferidasFormModel
  desativarCompartilhamentoProntuario: boolean
}

export interface NacionalidadeFormModel {
  nacionalidade: NacionalidadeEnum
  municipioNascimento?: MunicipioSelectModel
  portariaNaturalizacao?: string
  dataNaturalizacao?: LocalDate
  paisNascimento?: PaisSelectFieldModel
  dataEntradaPais?: LocalDate
}

export type CidadaoFci = CidadaoFciAtualizacaoQuery['cidadao']

export const estadoCivilRecord: Record<ID, EstadoCivilEnum> = {
  '1': EstadoCivilEnum.SOLTEIRO,
  '2': EstadoCivilEnum.CASADO,
  '3': EstadoCivilEnum.VIUVO,
  '4': EstadoCivilEnum.SEPARADO_JUDICIALMENTE,
  '5': EstadoCivilEnum.UNIAO_CONSENSUAL,
}

export const criancas0a9anosComQuemFicaRecord: Record<Criancas0a9AnosComQuemFicaEnum, string> = {
  ADULTO_RESPONSAVEL: 'Adulto responsável',
  OUTRAS_CRIANCAS: 'Outra(s) criança(s)',
  ADOLESCENTE: 'Adolescente',
  SOZINHA: 'Sozinha',
  CRECHE: 'Creche',
  OUTRO: 'Outro',
}

export const deficienciaRecord: Record<DeficienciaEnum, string> = {
  AUDITIVA: 'Auditiva',
  INTELECTUAL_COGNITIVA: 'Intelectual / Cognitiva',
  VISUAL: 'Visual',
  FISICA: 'Fisica',
  OUTRA: 'Outra',
}

export const situacaoMercadoTrabalhoRecord: Record<SituacaoMercadoTrabalhoEnum, string> = {
  EMPREGADOR: 'Empregador',
  ASSALARIADO_COM_CARTEIRA_TRABALHO: 'Assalariado com carteira de trabalho',
  ASSALARIADO_SEM_CARTEIRA_TRABALHO: 'Assalariado sem carteira de trabalho',
  AUTONOMO_COM_PREVIDENCIA_SOCIAL: 'Autônomo com previdência social',
  AUTONOMO_SEM_PREVIDENCIA_SOCIAL: 'Autônomo sem previdência social',
  APOSENTADO_PENSIONISTA: 'Aposentado / Pensionista',
  DESEMPREGADO: 'Desempregado',
  NAO_TRABALHA: 'Não trabalha',
  SERVIDOR_PUBLICO_MILITAR: 'Servidor público / Militar',
  OUTRO: 'Outro',
}

export const povoComunidadeTradicionalRecord: Record<PovoComunidadeTradicionalEnum, string> = {
  AGROEXTRATIVISTAS: 'Agroextrativistas - Povos ou Comunidades Tradicionais',
  CAATINGUEIROS: 'Caatingueiros - Povos ou Comunidades Tradicionais',
  CAICARAS: 'Caiçaras - Povos ou Comunidades Tradicionais',
  CERRADO: 'Cerrado - Povos ou Comunidades Tradicionais',
  CIGANOS: 'Ciganos - Povos ou Comunidades Tradicionais',
  COMUNIDADES_FUNDO_FECHO_PASTO: 'Comunidades de fundo e fecho de pasto - Povos ou Comunidades Tradicionais',
  EXTRATIVISTAS: 'Extrativistas - Povos ou Comunidades Tradicionais',
  FAXINALENSES: 'Faxinalenses - Povos ou Comunidades Tradicionais',
  GERAIZEIROS: 'Geraizeiros - Povos ou Comunidades Tradicionais',
  MARISQUEIROS: 'Marisqueiros - Povos ou Comunidades Tradicionais',
  PANTANEIROS: 'Pantaneiros - Povos ou Comunidades Tradicionais',
  PESCADORES_ARTESANAIS: 'Pescadores artesanais - Povos ou Comunidades Tradicionais',
  POMERANOS: 'Pomeranos - Povos ou Comunidades Tradicionais',
  POVOS_INDIGENAS: 'Povos indígenas - Povos ou Comunidades Tradicionais',
  POVOS_QUILOMBOLAS: 'Povos quilombolas - Povos ou Comunidades Tradicionais',
  QUEBRADEIRAS_COCO_BABACU: 'Quebradeiras de coco babaçu - Povos ou Comunidades Tradicionais',
  RETIREIROS: 'Retireiros - Povos ou Comunidades Tradicionais',
  RIBEIRINHOS: 'Ribeirinhos - Povos ou Comunidades Tradicionais',
  SERINGUEIROS: 'Seringueiros - Povos ou Comunidades Tradicionais',
  POVOS_DE_TERREIRO_MATRIZ_AFRICANA: 'Povos de terreiro / Matriz africana - Povos ou Comunidades Tradicionais',
  VAZANTEIROS: 'Vazanteiros - Povos ou Comunidades Tradicionais',
  OUTROS: 'Outros - Povos ou Comunidades Tradicionais',
  ACAMPADA: 'Acampada - População Campo, Floresta e Águas',
  ANDIROBEIRAS: 'Andirobeiras - População Campo, Floresta e Águas',
  ASSENTADA: 'Assentada - População Campo, Floresta e Águas',
  CAMPONESES: 'Camponeses - População Campo, Floresta e Águas',
  CASTANHEIRAS: 'Castanheiras - População Campo, Floresta e Águas',
  CATADORES_DE_MANGABA: 'Catadores de mangaba - População Campo, Floresta e Águas',
  ISQUEIROS: 'Isqueiros - População Campo, Floresta e Águas',
  JANGADEIROS: 'Jangadeiros - População Campo, Floresta e Águas',
  MORROQUIANOS: 'Morroquianos - População Campo, Floresta e Águas',
  POPULACOES_ATINGIDAS_POR_BARRAGENS: 'Populações atingidas por barragens - População Campo, Floresta e Águas',
  TRABALHADORES_RURAIS_ASSALARIADOS: 'Trabalhadores rurais assalariados - População Campo, Floresta e Águas',
  TRABALHADORES_RURAIS_TEMPORARIOS: 'Trabalhadores rurais temporários - População Campo, Floresta e Águas',
  VARJEIROS: 'Varjeiros - População Campo, Floresta e Águas',
}

export const escolaridadeRecord: Record<ID, EscolaridadeEnum> = {
  '1': EscolaridadeEnum.CRECHE,
  '2': EscolaridadeEnum.PRE_ESCOLA_EXCETO_CA,
  '3': EscolaridadeEnum.CLASSE_ALFABETIZADA_CA,
  '4': EscolaridadeEnum.ENSINO_FUNDAMENTAL_1_A_4_SERIES,
  '5': EscolaridadeEnum.ENSINO_FUNDAMENTAL_5_A_8_SERIES,
  '6': EscolaridadeEnum.ENSINO_FUNDAMENTAL_COMPLETO,
  '7': EscolaridadeEnum.ENSINO_FUNDAMENTAL_ESPECIAL,
  '8': EscolaridadeEnum.ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_1_A_4,
  '9': EscolaridadeEnum.ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_5_A_8,
  '10': EscolaridadeEnum.ENSINO_MEDIO_MEDIO_2_CICLO,
  '11': EscolaridadeEnum.ENSINO_MEDIO_ESPECIAL,
  '12': EscolaridadeEnum.ENSINO_MEDIO_EJA_SUPLETIVO,
  '13': EscolaridadeEnum.SUPERIOR_APERFEICOAMENTO_ESPECIALIZACAO_MESTRADO_DOUTORADO,
  '14': EscolaridadeEnum.ALFABETIZACAO_PARA_ADULTOS_MOBRAL_ETC,
  '15': EscolaridadeEnum.NENHUM,
}

export const doencaCardiacaAutorreferidoRecord: Record<DoencaCardiacaAutorreferidoEnum, string> = {
  INSUFICIENCIA_CARDIACA: 'Insuficiência cardíaca',
  OUTRA: 'Outra',
  NAO_SABE: 'Não sabe',
}

export const doencaRespiratoriaAutorreferidoRecord: Record<DoencaRespiratoriaAutorreferidoEnum, string> = {
  ASMA: 'Asma',
  DPOC_ENFISEMA: 'Dpoc enfisema',
  OUTRO_DOENCA_RESPIRATORIA: 'Outra doença respiratória',
  NAO_SABE_DOENCA_RESPIRATORIA: 'Não sabe doença respiratória',
}

export const doencaRinsAutorreferidoRecord: Record<DoencaRinsAutorreferidoEnum, string> = {
  INSUFICIENCIA_RENAL: 'Insuficiência renal',
  OUTRO: 'Outro',
  NAO_SABE: 'Não sabe',
}

export const pesoAutorreferidoRecord: Record<PesoAutorreferidoEnum, string> = {
  ABAIXO_DO_PESO: 'Abaixo do peso',
  PESO_ADEQUADO: 'Peso adequado',
  ACIMA_DO_PESO: 'Acima do peso',
}

export const origemAlimentacaoRecord: Record<OrigemAlimentacaoEnum, string> = {
  DOACAO_DE_POPULAR: 'Doação de popular',
  DOACAO_GRUPO_RELIGIOSO: 'Doação grupo religioso',
  DOACAO_RESTAURANTE: 'Doação restaurante',
  RESTAURANTE_POPULAR: 'Restaurante popular',
  OUTROS_ORIGEM_ALIMENTACAO: 'Outros',
}

export const higienePessoalRecord: Record<HigienePessoalEnum, string> = {
  ACESSO_AO_SANITARIO: 'Acesso ao sanitário',
  BANHO: 'Banho',
  HIGIENE_BUCAL: 'Higiene bucal',
  OUTROS_ACESSO_HIGIENE: 'Outros',
}

export const tempoSituacaoRuaRecord: Record<TempoSituacaoDeRuaEnum, string> = {
  MENOS_6_MESES: '< 6 meses',
  SEIS_A_12_MESES: '6 a 12 meses',
  UM_A_5_ANOS: '1 a 5 anos',
  MAIS_DE_5_ANOS: '> 5 anos',
}

export const quantidadeAlimentacaoDiariaRecord: Record<QuantidadeAlimentacaoDiariaEnum, string> = {
  UMA_POR_DIA: '1 vez',
  DUAS_A_3_POR_DIA: '2 ou 3 vezes',
  MAIS_DE_3: 'mais de 3 vezes',
}
